import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Toolbox } from 'src/app/classes/toolbox';
import { ToolboxRead } from 'src/app/classes/toolbox-read';
import { CodaltComponent } from 'src/app/codalt.component';
import { ToolboxDialogComponent } from 'src/app/pages/toolbox/toolbox-dialog/toolbox-dialog.component';
import { ToolboxService } from 'src/app/services/toolbox.service';

@Component({
    selector: 'app-past-toolboxes-dialog',
    templateUrl: './past-toolboxes-dialog.component.html',
    styleUrls: ['./past-toolboxes-dialog.component.scss'],
    standalone: false,
})
export class PastToolboxesDialogComponent extends CodaltComponent implements OnInit {
    toolboxes: Toolbox[];
    loading = true;

    constructor(
        public dialogRef: MatDialogRef<PastToolboxesDialogComponent>,
        public dialog: MatDialog,
        public toolboxService: ToolboxService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.toolboxService.getToolboxes().subscribe(toolboxes => {
                this.toolboxes = toolboxes.data;
                this.loading = false;
            })
        );
    }

    open(toolbox: Toolbox) {
        toolbox.read = new ToolboxRead();

        this.dialogRef.afterClosed().subscribe(() => {
            setTimeout(() => {
                this.dialog.open(ToolboxDialogComponent, {
                    panelClass: 'toolbox-dialog',
                    width: '99vw',
                    maxWidth: '1300px',
                    height: '99vh',
                    minHeight: '500px',
                    maxHeight: '99vh',
                    disableClose: true,
                    data: toolbox,
                });
            });
        });

        this.dialogRef.close();
    }

    close() {
        this.dialogRef.close();
    }
}
